import { Drawer, DrawerProps } from '@material-ui/core';
import { CSSProperties } from 'react';

export interface SDrawerProps {
  open: DrawerProps['open'];
  anchor?: DrawerProps['anchor'];
  variant?: DrawerProps['variant'];
  children: React.ReactNode;
  style?: CSSProperties;
}

const SDrawer = ({
  anchor = 'right',
  variant = 'persistent',
  open = false,
  children,
  style
}: SDrawerProps) => (
  <Drawer
    SlideProps={{ unmountOnExit: true }}
    open={open}
    anchor={anchor}
    style={{ zIndex: 1200, ...style }}
    variant={variant}>
    {children}
  </Drawer>
);

export default SDrawer;
